<template>
  <div>
    <e-chart v-if="hasData" :options="chartOptions" autoresize></e-chart>
    <div v-else-if="loaded">
      <span>{{ $t("No Vulnerable Packages") }}</span>
      <b-icon icon="hand-thumbs-up" variant="success" font-scale="1" style="margin-left: 4px"></b-icon>
    </div>
    <SpinnerCmpt v-else></SpinnerCmpt>
  </div>
</template>

<script>
import SpinnerCmpt from '@/xvisor/components/SpinnerCmpt.vue';
import colorPalette from '@/xvisor/constants/colorPalette';
import themeStyle from '@/xvisor/utilities/themeStyle';

export default {
  props: {
    url: {
      type: String,
      required: true,
    },
    timeRange: {
      type: Object,
      required: true,
    },
  },
  components: {
    SpinnerCmpt,
  },
  data() {
    return {
      series: [],
      colorMap: {
        Critical: colorPalette.danger,
        Warning: colorPalette.warning,
        Notice: colorPalette.info,
      },
      loaded: false,
    };
  },
  mounted() {
    this.httpGet();
  },
  watch: {
    timeRange() {
      this.httpGet();
    },
  },
  computed: {
    hasData() {
      return this.loaded && this.series && this.series.length > 0;
    },
    toggleColor() {
      return themeStyle.styleToggle(colorPalette.black, colorPalette.white);
    },
    httpParams() {
      return {
        params: {
          start: this.timeRange.start.toISOString(),
          end: this.timeRange.end.toISOString(),
        },
      };
    },
    formatData() {
      return this.series.map((item) => {
        const {
          name,
          count,
          data,
        } = item;
        return {
          value: count,
          program: data,
          itemStyle: { color: this.colorMap[name] || this.getRandomColor() },
          name,
        };
      });
    },
    chartOptions() {
      return {
        title: {
          show: false,
        },
        legend: {
          bottom: 4,
          textStyle: {
            color: this.toggleColor,
          },
          formatter: (name) => {
            const dataItem = this.formatData.find((item) => item.name === name);
            return dataItem ? `${name}: ${dataItem.value}` : name;
          },
        },
        tooltip: {
          trigger: 'item',
          formatter: (params) => {
            let tooltipContent = `${params.marker} ${params.name}: ${params.value}<br/>`;
            if (params.data.program.length > 0) {
              tooltipContent = tooltipContent.concat('<br/>Programs:<br/>');
              const programs = params.data.program.map((item) => `${item}`);
              programs.join('<br>');
              tooltipContent = tooltipContent.concat(programs.join('<br>'));
            }
            return tooltipContent;
          },
        },
        series: [
          {
            type: 'pie',
            avoidLabelOverlap: true,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2,
            },
            radius: '67%',
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            data: this.formatData,
            top: '-15%',
          },
        ],
      };
    },
  },
  methods: {
    httpGet() {
      this.loaded = false;
      this.$http
        .get(this.url, this.httpParams)
        .then((response) => {
          this.series = response.data;
        })
        .finally(() => { this.loaded = true; });
    },
    getRandomColor() {
      // Random color picker just in case name is changed and someone forgets to update the color.
      return `#${Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0')}`;
    },
  },
};
</script>
